// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.redirect-to-page{min-height:100px}.redirect-to-page p{text-align:center;margin-bottom:10px}`, "",{"version":3,"sources":["webpack://./ui-components/bank-transfer-pse/success/style.scss"],"names":[],"mappings":"AAAA,kBACE,gBAAA,CACA,oBACE,iBAAA,CACA,kBAAA","sourcesContent":[".redirect-to-page{\n  min-height: 100px;\n  p{\n    text-align: center;\n    margin-bottom: 10px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"redirect-to-page": `redirect-to-page`
};
export default ___CSS_LOADER_EXPORT___;
